export default {
  "Academy, Learning & Development Programmes": "academy@allbright.co",
  "Club Membership": "membership@allbright.co",
  "Corporate Club Memberships": "membership@allbright.co",
  "Digital Membership": "digital@allbright.co",
  "AllBright Events": "programming@allbright.co",
  "Private Hire Events": "events@allbright.co",
  "Mayfair Club Reception": "mayfairreservations@allbright.co",
  "Commercial Partnerships": "partnerships@allbright.co",
  Press: "digital@allbright.co",
  NFT: "nft@allbright.co",
  Mentorship: "digital@allbright.co",
  "Report User": "digital@allbright.co",
  Other: "digital@allbright.co",
};
